export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/89c4c101dce5-tooliconreg.jpg',
  },
  title: "What's your car registration number?",
}
